import "antd/es/form/style";
import _Form from "antd/es/form";
var _excluded = ["name", "children", "ignoreFormListField"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";
import get from "rc-util/es/utils/get";
import { useContext, useMemo } from 'react';
import set from "rc-util/es/utils/set";
import { FormListContext } from '../List';
import { ProFormContext, merge } from '@ant-design/pro-utils';

var ProFormDependency = function ProFormDependency(_ref) {
  var name = _ref.name,
      children = _ref.children,
      ignoreFormListField = _ref.ignoreFormListField,
      rest = _objectWithoutProperties(_ref, _excluded);

  var context = useContext(ProFormContext); // ProFromList 的 filed，里面有name和key

  var formListField = useContext(FormListContext);
  var names = useMemo(function () {
    if (formListField.name === undefined) {
      return name;
    }

    return name.map(function (itemName) {
      return [formListField.listName, itemName].flat(1);
    });
  }, [formListField.listName, formListField.name, name]);
  return /*#__PURE__*/React.createElement(_Form.Item, _extends({}, rest, {
    noStyle: true,
    shouldUpdate: function shouldUpdate(prevValues, nextValues) {
      var finalNames = names; // ignoreFormListField 为 true 时，应从全局取值，要将 names 中各项的路径前缀(formListField.listName)剥离掉

      if (ignoreFormListField && Array.isArray(formListField.listName) && formListField.listName.length > 0) {
        finalNames = names.map(function (nameItem) {
          return Array.isArray(nameItem) ? nameItem.slice(formListField.listName.length) : nameItem;
        });
      }

      return finalNames.some(function (nameItem) {
        var arrayName = Array.isArray(nameItem) ? nameItem : [nameItem];
        return get(prevValues, arrayName) !== get(nextValues, arrayName);
      });
    }
  }), function (form) {
    // 不在 FormList 中时，返回声明的全局依赖值
    if (formListField.name === undefined) {
      var values = names.reduce(function (pre, next) {
        var _context$getFieldsFor;

        var value = context === null || context === void 0 ? void 0 : (_context$getFieldsFor = context.getFieldsFormatValue) === null || _context$getFieldsFor === void 0 ? void 0 : _context$getFieldsFor.call(context, [next]);
        var noFormatValue = form.getFieldsValue([next]);
        return merge({}, pre, noFormatValue, value);
      }, {});
      return children === null || children === void 0 ? void 0 : children(_objectSpread({}, values), form);
    } // 在 FormList 中时
    // ignoreFormListField === true 时取全局依赖值


    if (ignoreFormListField) {
      var _nameValues = name.reduce(function (pre, namePath) {
        var finalNamePath = [namePath].flat(1);
        var fieldValue = form.getFieldValue(finalNamePath);
        return set(pre, [namePath].flat(1), fieldValue, false);
      }, {});

      return children === null || children === void 0 ? void 0 : children(_objectSpread({}, _nameValues), form);
    } // ignoreFormListField === false 时，取局部依赖值


    var nameValues = name.reduce(function (pre, namePath) {
      var finalNamePath = [formListField.listName, namePath].flat(1);
      var fieldValue = form.getFieldValue(finalNamePath);
      return set(pre, [namePath].flat(1), fieldValue, false);
    }, {});
    return children === null || children === void 0 ? void 0 : children(_objectSpread({}, nameValues), form);
  });
};

export default ProFormDependency;